import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import { api_get } from "api/utils";
import useUserIdentity from "hooks/useUserIdentity";
import useWorkKey from 'hooks/useWorkKey';
export default function CollabEmailRender() {

    const { collabKey } = useParams();
    const [html, setHtml] = useState('');
    const { currentIdentity } = useUserIdentity();
    const workKey = useWorkKey();

    useEffect(() => {
        console.log("collabKey", collabKey);
        if(!workKey) return;
        console.log("collabKey calling render", collabKey);
        api_get("/collab/email-render", {
            collab: collabKey || "",
            identity: currentIdentity.uuid
        })
            .then(async (res) => {
                const content = await res.json();
                setHtml(content.html_content);
                console.log(html);
            });
    }, [collabKey, currentIdentity?.uuid, workKey]);

    return (
        <Stack ml={3} mt={5} width={600} >

		<div dangerouslySetInnerHTML={{__html: html}} />
        </Stack>
    );
}
